import React, {useEffect, useState} from 'react';
import './Settingspopup.css'
import { useNavigate } from 'react-router-dom';
import Switch from 'react-switch';
import { useDispatch } from 'react-redux';
import { deletePost, changeVisibility } from '../../actions/postAction';
import { toast } from 'react-toastify';
import Loader from '../../layout/Loder';
import Dropdown from './Dropdown';
import DeletePopup from './DeletePopup';

const Settingspopup = ({closeSettings, post, setpost, onRelease }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checked, setchecked] = useState(post.visibility === "true");
  const [loading, setloading] = useState(true);
  const [btnloading, setbtnloading] = useState(false);
  const [savebtnloading, setsavebtnloading] = useState(false);
  const [Status, setStauts] = useState(post.status);
  const [selectedOption, setselectedOption] = useState(post.status == "standby"? { value: 'standby', label: 'Standby', color: 'blue', background:'rgb(255, 255, 133)' }:(post.status==="active")?{ value: 'active', label: 'Active', color: 'green',background:'rgb(170, 255, 170)' }: { value: 'released', label: 'Released', color: 'rgb(255, 123, 0)',background:'rgb(170, 255, 170)' });
  const [deletepopup, setdeletepopup] = useState(false);
  const handleChange = (e) => {
    setchecked(!checked);
  }
const options = [
  { value: 'standby', label: 'Standby', color: 'blue', background:'rgb(255, 255, 133)' },
  { value: 'active', label: 'Active', color: 'green',background:'rgb(170, 255, 170)' },
  { value: 'released', label: 'Released', color: 'rgb(255, 123, 0)',background:'rgb(170, 255, 170)' },
];
//Delete handler
const beginDelete = async() => {
  setdeletepopup(!deletepopup);
  // handleDelete();
}
const handleDelete = async() => {
  try{
    const data = {
      postId:post._id,
    }
    setbtnloading(true);
    const res = await dispatch(deletePost(data));
    if(res.success){
      toast.success("Record deleted");
      navigate("/mynotes");
    }else{
      toast.error(res.message);
    }
  }catch(error){
    toast.error(error);
  }finally{
    setbtnloading(false);
  }
}

const saveChanges = async() => {
  try{
    const data = {
      postId: post._id,
      visibility: checked ,
      status: Status,
    };
    setsavebtnloading(true);
    const res = await dispatch(changeVisibility(data));
    if(res && res.status == 409){
      toast.error(res.data.message);
    }else{
      const updatedPost = { ...post };
      updatedPost.visibility = String(checked);
      updatedPost.status = String(Status);
      // console.log(updatedPost);
      setpost(updatedPost);
      toast.success("Saved");
    }
  }catch(error){
    toast.error(error);
  }finally{
    setsavebtnloading(false);
  }
}
  useEffect(() => {
    // console.log(post.visibility === "true");
    setchecked(post.visibility === "true");
  }, []);
  useEffect(() => {
    setloading(false);
  }, [checked]);

  

  return (
    <>
    <div className="blur-background" onClick={(e) => closeSettings(e)}></div>

    <div className={`popup settings-popup ${deletepopup ? "blurred" : ""}`}>
      {loading? (
        <Loader/>
      ):(
        <>
        <div className="sp-header">
          <h2>Settings</h2>
          <button type="button" className="sp-close" onClick={(e) => closeSettings(e)} aria-label="Close">
            <i className='bx bx-x'></i>
          </button>
        </div>

        <div className="sp-body">
          <div className="sp-row">
            <div className="sp-row-text">
              <label htmlFor="material-switch" className="sp-label">Visibility</label>
              <p className="sp-hint">Turning this off removes your record from Dmyor search.</p>
            </div>
            <div className="sp-row-control">
              <Switch
                checked={checked}
                onChange={handleChange}
                onColor="#F9861B"
                onHandleColor="#ffffff"
                handleDiameter={18}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 3px rgba(0,0,0,0.15)"
                activeBoxShadow="0px 0px 1px 6px rgba(255, 123, 0, 0.18)"
                height={22}
                width={40}
                className="react-switch"
                id="material-switch"
              />
            </div>
          </div>

          {post.statis!=="released" &&
            <div className="sp-row">
              <div className="sp-row-text">
                <span className="sp-label">Status</span>
                <p className="sp-hint">Where this record sits right now.</p>
              </div>
              <div className="sp-row-control">
                <Dropdown id="status" setStatus={setStauts} selectedOption={selectedOption} setselectedOption={setselectedOption} />
              </div>
            </div>
          }

          <div className="sp-actions">
            <button
              className="sp-btn sp-btn-primary"
              disabled={savebtnloading}
              onClick={saveChanges}
            >
              {savebtnloading ? "Saving…" : "Save"}
            </button>
          </div>

          {onRelease && post.status !== "released" && (
            <div className="sp-release-section">
              <p>Mark this record as complete and release it.</p>
              <button className="sp-btn sp-btn-ghost" onClick={onRelease}>
                {post.method === "digicoins" ? "Release" : "Change Status"}
              </button>
            </div>
          )}

          {!(post.category === "Thoughts" && post.planId) && (
            <div className="sp-delete">
              <p>This permanently deletes the record.</p>
              <button
                className="sp-btn sp-btn-danger"
                disabled={btnloading}
                onClick={beginDelete}
              >
                {btnloading ? "Deleting…" : "Delete"}
              </button>
            </div>
          )}
        </div>
        </>
      )}
    </div>
    {
      deletepopup && <DeletePopup handleDelete={handleDelete} setdeletepopup={setdeletepopup}/>
    }
    </>
  );
};

export default Settingspopup;
